import { ReactComponent as RequestIcon } from "../../assets/icons/stock_icons/Request_Icon.svg";
import { ReactComponent as TimeIcon } from "../../assets/icons/stock_icons/Time_Icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/icons/stock_icons/Border_Cross_Icon.svg";
import { ReactComponent as ClientIcon } from "../../assets/icons/stock_icons/Client_Icon.svg";
import { ReactComponent as TrayIcon } from "../../assets/icons/stock_icons/Tray_Icon.svg";
import { ReactComponent as SalesPersonIcon } from "../../assets/icons/stock_icons/Sales_Person_Icon.svg";
import { ReactComponent as CollectIcon } from "../../assets/icons/stock_icons/Collect_Icon.svg";
import { ReactComponent as MessageIcon } from "../../assets/icons/stock_icons/Message_Icon.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/stock_icons/Eye_Icon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/stock_icons/Calendar_Icon.svg";
import { ReactComponent as PoIcon } from "../../assets/icons/stock_icons/PO_icon.svg";
import { Button, IconButton } from "@mui/material";
import SearchModal from "./modals/searchModal/SearchModal";
import { useState } from "react";
import apiClient from "../../lib/api_client";
import { useQueryClient } from "@tanstack/react-query";

const RequestCard = ({
  type,
  requestId,
  requestTime,
  trayName,
  clientName,
  salesPersonName,
  purchaseNo,
  isOccupied = false,
  status,
  responseTime,
  message,
  requestCompletedTime,
  id,
  refetch,
}) => {
  const cardDetails = [
    {
      name: trayName,
      icon: <TrayIcon width={20} height={20} />,
    },
    {
      name: clientName,
      icon: <ClientIcon width={20} height={20} />,
    },
    {
      name: salesPersonName,
      icon: <SalesPersonIcon width={20} height={20} />,
    },
  ];

  const [openText, setOpenText] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");
  const queryClient = useQueryClient();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = async (id) => {
    setIsProcessing(true);
    try {
      if (type === "Request") {
        await apiClient.put(`/request/${id}`, { action: "accept" });
      } else if (type === "Collect") {
        await apiClient.put(`/request/${id}`, { action: "received" });
      }

      await refetch();
      queryClient.invalidateQueries(["occupiedTray"]);
      queryClient.invalidateQueries(["availableTray"]);
    } catch (error) {
      console.error("Action failed:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div
      style={{
        color: "#fff",
        backgroundColor: "#0D0D0D",
        width: "100%",
        padding: "0.9rem",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}>
      {/* First Row */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
          <div
            style={{
              display: "flex",
              padding: "0.25vw 0.7vw",
              backgroundColor: `${type === "Request" ? "#E77B7B0D" : " #50C8780D"
                }`,
              alignItems: "center",
              gap: "0.7rem",
              borderRadius: "0.25vw",
            }}>
            {type === "Request" ? (
              <RequestIcon width={15} height={15} />
            ) : (
              <CollectIcon width={15} height={15} />
            )}
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: 400,
                color: `${type === "Request" ? "#E77B7B" : "#50C878"}`,
              }}>
              {type}
            </p>
          </div>

          <p
            style={{
              color: "#8B8B8B",
              fontFamily: "Poppins",
              fontWeight: 500,
            }}>
            # {requestId}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
          <div
            style={{
              backgroundColor: "#141414",
              borderRadius: "0.25vw",
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              padding: "0.15vw 0.4vw",
            }}>
            {status !== "Completed" && (
              <>
                <TimeIcon width={15} height={15} />
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "0.6vw",
                  }}>
                  {requestTime}
                </p>
              </>
            )}
            {status === "Completed" && (
              <>
                <CalendarIcon width={15} height={15} />
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "0.55vw",
                  }}>
                  {requestCompletedTime}
                </p>
              </>
            )}
          </div>
          {type === "Request" && status === "Pending" && (
            <IconButton sx={{m: 0, p: 0}}>
              <CrossIcon
                width={20}
                height={20}
                onClick={() => setOpenDeleteModal(true)}
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          )}
        </div>
      </div>

      {/* Second Row to Fourth Row */}
      {cardDetails.map((el, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "0.7rem",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div
            key={index}
            style={{
              display: "flex",
              columnGap: "0.7rem",
            }}>
            <span>{el.icon}</span>
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: `${index === 0 ? "600" : "400"}`,
              }}>
              {el.name}
            </p>
          </div>
          {status === "Completed" && index === 0 && (
            <div
              style={{
                backgroundColor: "#141414",
                borderRadius: "0.25vw",
                display: "flex",
                alignItems: "center",
                gap: "0.4rem",
                padding: "3px 8px",
              }}>
              <TimeIcon width={15} height={15} />
              <p
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: "0.6vw",
                }}>
                {requestTime}
              </p>
            </div>
          )}

          {status !== "Completed" && index === 0 && purchaseNo && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.4rem",
              }}>
              <PoIcon width={16} height={16} />
              <p
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                }}>
                {purchaseNo}
              </p>
            </div>
          )}

          {status === "Completed" && index === 2 && (
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: `${index === 0 ? "600" : "400"}`,
              }}>
              {responseTime}
            </p>
          )}
        </div>
      ))}

      {status === "Cancelled" && (
        <div
          style={{
            display: "flex",
            gap: "0.7rem",
            alignItems: "center",
          }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}>
            <MessageIcon width={20} height={20} />
          </span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              position: "relative",
              flex: 1,
              minWidth: 0,
            }}>
            <p
              style={{
                fontFamily: "Poppins",
                fontWeight: "400",
                whiteSpace: "pre-line",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                margin: 0,
                padding: 0,
                width: "100%",
                maxWidth: "100%",
              }}
              title={message}>
              {message || "Message"}
            </p>
            {message && (
              <EyeIcon
                width={18}
                height={18}
                style={{ marginLeft: 4, cursor: "pointer" }}
                onClick={() => setOpenText(true)}
              />
            )}
          </div>
        </div>
      )}

      {/* Button */}
      {status === "Pending" && (
        <Button
          sx={{
            width: "100%",
            height: "3vw",
            background:
              type === "Collect"
                ? "#50C878"
                : isOccupied
                  ? "#262626"
                  : "#E77B7B",
            color:
              type === "Collect"
                ? "#000000"
                : isOccupied
                  ? "#CCCCCC"
                  : "#000000",
            fontFamily: "Poppins",
            fontSize: ".9vw",
            fontWeight: "600",
            borderRadius: "0.25vw",
            textTransform: "capitalize",
            "&.Mui-disabled": {
              color:
                type === "Collect"
                  ? "#000000"
                  : isOccupied
                    ? "#CCCCCC"
                    : "#000000",
            },
          }}
          disabled={isProcessing || (type === "Request" && isOccupied)}
          onClick={() => handleClick(id)}>
          {isProcessing
            ? type === "Request"
              ? "Accepting..."
              : "Receiving..."
            : type === "Request"
              ? "Accept"
              : "Received"}
        </Button>
      )}
      {(openText || openDeleteModal) && (
        <SearchModal
          headLabel={
            openText
              ? `StockMessage`
              : `Delete request of ${salesPersonName} # ${requestId}`
          }
          remark={message || ""}
          openModal={!!(openText || openDeleteModal)}
          handleClose={() => {
            setOpenText(false)
            setOpenDeleteModal(false)
          }}
          requestTitle={
            openText ? `Message of ${salesPersonName} # ${requestId}` : ""
          }
          setRemark={!openText ? (text) => setDeleteMessage(text) : ""}
          id={id}
          refetch={refetch}
        />
      )}
    </div>
  )
};

export default RequestCard;
